import React, {Component} from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { Form, Input, Checkbox, Button } from 'antd';

import { serverCreateAccount } from '../actions';

import Page from '../../shared/components/Page';

class CreateAccount extends Component{
    constructor(props){
        super(props);

        this.state = {
            newAccount: {
                firstName: '',
                lastName: '',
                username: '',
                password: '',
                confirmedPassword: '',
                admin: false,
            }
        }
    }

    handleCheckboxChange(e){
        let tmpNewAccount = {...this.state.newAccount};
        tmpNewAccount[e.target.id] = e.target.checked;
        this.setState({
            newAccount: tmpNewAccount,
        });
    }

    handleInputChange(e){
        let tmpNewAccount = {...this.state.newAccount};
        tmpNewAccount[e.target.id] = e.target.value;
        this.setState({
            newAccount: tmpNewAccount,
        });
    }

    isValid(){
        const newAccount = this.state.newAccount;
        return newAccount.firstName.length > 0 && newAccount.lastName.length > 0
                 && newAccount.username.length > 0 && newAccount.password.length >= 6
                  && (newAccount.password === newAccount.confirmedPassword);
    }
    
    render(){
        return(
            <Page>
                <Page.MainArea>
                    <div className="container-with-padding">
                        <h4 className="heading-level-1" style={{
                            marginBottom: 16,
                        }}>Create Account</h4>
                        <Form>
                            <Form.Item label="First Name" style={{ marginBottom: 5}}>
                                <Input placeholder="John" onChange={this.handleInputChange.bind(this)} 
                                    value={this.state.newAccount.firstName} id="firstName" />
                            </Form.Item>
                            <Form.Item label="Last Name" style={{ marginBottom: 5}}>
                                <Input placeholder="Appleseed" onChange={this.handleInputChange.bind(this)} 
                                    value={this.state.newAccount.lastName} id="lastName"  />
                            </Form.Item>
                            <Form.Item label="Username" style={{ marginBottom: 5}}>
                                <Input placeholder="user@example.com" onChange={this.handleInputChange.bind(this)}
                                    value={this.state.newAccount.username} id="username" />
                            </Form.Item>
                            <Form.Item label="Password" style={{ marginBottom: 5}}>
                                <Input placeholder="fn3424nfdafkfadf" onChange={this.handleInputChange.bind(this)}
                                    value={this.state.newAccount.password} type="password" id="password" />
                            </Form.Item>
                            <Form.Item label="Confirm Password" style={{ marginBottom: 5}}>
                                <Input placeholder="fn3424nfdafkfadf" onChange={this.handleInputChange.bind(this)}
                                    value={this.state.newAccount.confirmedPassword} type="password" id="confirmedPassword" />
                            </Form.Item>
                            <Form.Item label="" style={{ marginBottom: 10, marginTop: 5 }}>
                                <Checkbox value={this.state.newAccount.admin} id="admin" 
                                    onChange={this.handleCheckboxChange.bind(this)}>Admin Account</Checkbox>
                            </Form.Item>
                            <Form.Item style={{ marginBottom: 5}}>
                                <Button type="primary" icon="user-add" 
                                    disabled={!this.isValid()} onClick={() => {
                                        this.props.createAccount(this.state.newAccount);
                                    }}>Save Account</Button>
                            </Form.Item>
                        </Form>
                    </div>
                </Page.MainArea>
            </Page>
        )
    }
}

CreateAccount.propTypes = {
    createAccount: PropTypes.func,
}

// Map props to the store

const mapStateToProps = () => ({
});
  
const mapDispatchToProps = (dispatch) => ({
    createAccount: (account) => {
        dispatch(serverCreateAccount(account));
    },
});
  
const CreateAccountContainer = connect(mapStateToProps,mapDispatchToProps)(CreateAccount);

export default CreateAccountContainer;


// WEBPACK FOOTER //
// ./src/admin/pages/CreateAccount.js